import React from "react";
import { Link } from "react-router-dom";
import { Compass, Home, Sparkles } from "lucide-react";
import { Layout } from "../components/Layout";
import { useI18n } from "../i18n";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-24 text-center" data-testid="not-found-page">
        <div className="h-20 w-20 rounded-full bg-primary/8 text-primary flex items-center justify-center mx-auto mb-6">
          <Compass className="h-10 w-10" />
        </div>
        <div className="text-6xl font-heading font-bold text-primary">404</div>
        <h1 className="mt-3 text-2xl sm:text-3xl font-heading font-semibold text-slate-900">
          {t("notfound.title")}
        </h1>
        <p className="mt-3 text-slate-500">{t("notfound.sub")}</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" data-testid="notfound-home-btn" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary text-white font-semibold px-6 py-3 hover:bg-primary/90 transition-colors">
            <Home className="h-4 w-4" /> {t("notfound.home")}
          </Link>
          <Link to="/esperienze" data-testid="notfound-experiences-btn" className="inline-flex items-center justify-center gap-2 rounded-full border border-primary text-primary font-semibold px-6 py-3 hover:bg-primary/5 transition-colors">
            <Sparkles className="h-4 w-4" /> {t("notfound.experiences")}
          </Link>
        </div>
      </div>
    </Layout>
  );
}
